/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a dedicated folder for the files you use in this exercise. Keep the original workbook there under a source name, and put each downloaded result under a name that describes its purpose. A filename such as workshop-review-02.xlsx is easier to recognize than several copies called Book1.xlsx. The exact naming pattern matters less than consistently distinguishing the untouched original from the file you just edited.`)
};

const zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为本次练习准备专用文件夹，将原始工作簿保留为来源文件，并给下载结果使用能说明用途的名称。workshop-review-02.xlsx 比多个 Book1.xlsx 更容易识别。具体命名方式不是重点，重点是持续区分未修改原件和刚编辑的文件。`)
};

/**
* | output |
* | --- |
* | "Create a dedicated folder for the files you use in this exercise. Keep the original workbook there under a source name, and put each downloaded result under ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_5_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_5_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_5_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.5.paragraphs.0" }